var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_426_128",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 9
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 0H1.33333C0.596954 0 0 0.537258 0 1.2V7.8C0 8.46274 0.596954 9 1.33333 9H12.6667C13.403 9 14 8.46274 14 7.8V1.2C14 0.537258 13.403 0 12.6667 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_426_128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 0H1.33333C0.596954 0 0 0.537258 0 1.2V7.8C0 8.46274 0.596954 9 1.33333 9H12.6667C13.403 9 14 8.46274 14 7.8V1.2C14 0.537258 13.403 0 12.6667 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33332 4.50001C9.33332 5.65981 8.28866 6.60001 6.99999 6.60001C5.71132 6.60001 4.66666 5.65981 4.66666 4.50001C4.66666 3.82801 6.23332 3.54601 7.55199 3.65221C7.69199 3.61861 7.84266 3.60001 7.99999 3.60001C8.73666 3.60001 9.33332 4.00321 9.33332 4.50001Z",
    fill: "#0048AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66666 4.19999C6.66666 4.19999 7.26332 3.59999 7.99999 3.59999C8.73666 3.59999 9.33332 4.00319 9.33332 4.49999C9.33332 3.34019 8.28866 2.39999 6.99999 2.39999C6.06866 2.39999 5.26466 2.89079 4.89066 3.60119C4.66666 4.19999 4.66666 4.37519 4.66666 4.49999C4.99999 4.79999 5.37066 4.79999 5.66666 4.79999C5.96266 4.79999 6.22866 4.68419 6.41199 4.49999L6.66666 4.19999Z",
    fill: "#CD0027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99999 2.99999H11.3333L9.99999 1.79999H9.33332L9.99999 2.99999ZM3.99999 2.99999H2.66666L3.99999 1.79999H4.66666L3.99999 2.99999ZM9.99999 5.99999H11.3333L9.99999 7.19999H9.33332L9.99999 5.99999ZM3.99999 5.99999H2.66666L3.99999 7.19999H4.66666L3.99999 5.99999Z",
    fill: "#252526"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKr);
export default __webpack_public_path__ + "static/media/KR.5255fd102b79aafeb57d72643ab649d5.svg";
export { ForwardRef as ReactComponent };